import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input } from 'antd';
import { kedoRegister } from './kedoApi';
import './KedoShell.css';

const KedoRegisterPage = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const onFinish = async values => {
        setLoading(true);
        setError('');
        try {
            await kedoRegister({
                email: values.email,
                password: values.password,
                full_name: values.full_name,
                phone: values.phone,
                organization_name: values.organization_name
            });
            navigate('/kedo/app', { replace: true });
        } catch (e) {
            setError(
                e?.response?.data?.message ||
                    e.message ||
                    'Не удалось зарегистрироваться'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="kedo-auth-wrap">
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
            />
            <div className="kedo-auth-card">
                <Link to="/kedo" className="kedo-brand">
                    <span className="kedo-brand-mark">Kedo</span>
                </Link>
                <h1>Регистрация</h1>
                <p className="muted">
                    Создайте организацию и войдите в кабинет Kedo
                </p>
                {error ? (
                    <Alert
                        type="error"
                        message={error}
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                ) : null}
                <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="full_name"
                        label="ФИО"
                        rules={[{ required: true, message: 'Укажите ФИО' }]}
                    >
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        name="organization_name"
                        label="Название организации"
                    >
                        <Input size="large" placeholder="ООО «Пример»" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Укажите email' },
                            { type: 'email', message: 'Некорректный email' }
                        ]}
                    >
                        <Input size="large" autoComplete="email" />
                    </Form.Item>
                    <Form.Item name="phone" label="Телефон">
                        <Input size="large" placeholder="+7900…" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Пароль"
                        rules={[
                            { required: true, message: 'Укажите пароль' },
                            { min: 8, message: 'Минимум 8 символов' }
                        ]}
                    >
                        <Input.Password
                            size="large"
                            autoComplete="new-password"
                        />
                    </Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        size="large"
                        loading={loading}
                        style={{
                            background: '#1b7a55',
                            borderColor: '#1b7a55'
                        }}
                    >
                        Создать аккаунт
                    </Button>
                </Form>
                <p style={{ marginTop: 18, marginBottom: 0 }}>
                    Уже есть аккаунт? <Link to="/kedo/login">Войти</Link>
                </p>
            </div>
        </div>
    );
};

export default KedoRegisterPage;
